import {
  StandardEditResponseModel,
  StandardResponseModel,
} from "../pages/shared/models/standard-response-model";
import { CountryModel } from "../pages/shared/models/countryModel";
import { CityModel } from "../pages/shared/models/cityModel";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getCities(
  filter: any,
  limit?: number,
  page?: number,
): Promise<StandardResponseModel<CountryModel>> {
  try {
    const authorizationHeader = configAuthorizationHeader();

    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .post(
        `${API_URL}/cities?${page ? "page=" + page : ""}`,
        filter,
        authorizationHeader,
      )
      .then((response) => {
        return response?.data as StandardResponseModel<CountryModel>;
      });
  } catch (error) {
    console.error(error);
    return Promise.reject();
  }
}

async function getCityById(cityId: number, page?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/cities/${cityId}?${page ? "page=" + page : ""}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function createCity(
  data: CityModel,
): Promise<StandardResponseModel<CityModel>> {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .post(
        `${API_URL}/cities/create`,
        {
          ...data,
          province: data.province ? data.province.provinceId : undefined,
        },
        authorizationHeader,
      )
      .then((response) => {
        return response?.data as StandardResponseModel<CityModel>;
      });
  } catch (error) {
    return Promise.reject(error);
  }
}

async function editCity(cityId: number, updateData: CityModel) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .put(
        `${API_URL}/cities/${cityId}`,
        {
          ...updateData,
          province: updateData.province
            ? updateData.province.provinceId
            : undefined,
          cityId: undefined,
        },
        authorizationHeader,
      )
      .then((response) => response?.data as StandardEditResponseModel);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function deleteCityById(cityId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.delete(
      `${API_URL}/cities/${cityId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getCities,
  getCityById,
  createCity,
  editCity,
  deleteCityById,
};
